import React from 'react';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import { useIntl } from 'react-intl';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { connect } from 'react-redux';

import SectionBookingFlow from './SectionBookingFlow/SectionBookingFlow';
import SectionArtistProfiles from './SectionArtistProfiles/SectionArtistProfiles';
import SectionQuote from './SectionQuote/SectionQuote';
import SectionHowPaymentsWork from './SectionHowPaymentsWorks/SectionHowPaymentsWork';
import SectionCancellingBooking from './SectionCancellingBooking/SectionCancellingBooking';
import SectionHero from './SectionHero/SectionHero';
import classNames from 'classnames/bind';
import SectionBenefits from './SectionBenefits/SectionBenefits';

import css from './HowItWorks.module.css';

const HowItWorksPageComponent = props => {
  const { scrollingDisabled } = props;

  const intl = useIntl();
  const title = intl.formatMessage({ id: 'HowItWorksPage.title' });

  return (
    <Page
      title={title}
      scrollingDisabled={scrollingDisabled}
      openGraphType="website"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: title,
      }}
    >
      <LayoutSingleColumn
        topbar={
          <>
            <TopbarContainer currentPage="HowItWorksPage" />
          </>
        }
        footer={<FooterContainer />}
      >
        <SectionHero
          intl={intl}
          className={classNames(css.section, css.sectionGrey)}
          titleClassName={css.h1}
        />
        <hr className={css.divider} />
        <SectionBenefits
          intl={intl}
          className={classNames(css.section, css.sectionWhite)}
          titleClassName={css.h2}
        />
        <hr className={css.divider} />
        <SectionBookingFlow
          intl={intl}
          className={classNames(css.section, css.sectionGrey)}
          titleClassName={css.h2}
        />
        <hr className={css.divider} />
        <SectionArtistProfiles
          intl={intl}
          className={classNames(css.section, css.sectionWhite)}
          titleClassName={css.h2}
        />
        <hr className={css.divider} />
        <SectionQuote
          intl={intl}
          className={classNames(css.section, css.sectionGrey)}
          titleClassName={css.h2}
        />
        <hr className={css.divider} />
        <SectionHowPaymentsWork
          intl={intl}
          className={classNames(css.section, css.sectionWhite)}
          titleClassName={css.h2}
        />
        <hr className={css.divider} />
        <SectionCancellingBooking
          intl={intl}
          className={classNames(css.section, css.sectionGrey)}
          titleClassName={css.h2}
        />
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const HowItWorksPage = compose(
  withRouter,
  connect(mapStateToProps)
)(HowItWorksPageComponent);

export default HowItWorksPage;
